import { PopoverSurface, PopoverSurfaceProps } from '@fluentui/react-components';


interface PopoverSurfaceCustomProps {
    rcName?: string;   
}

const PopoverSurfaceCustom = (props: PopoverSurfaceCustomProps & PopoverSurfaceProps) => {
    return (
      <PopoverSurface {...props}></PopoverSurface>
    );
};

export default PopoverSurfaceCustom;